﻿import React from 'react';
import { connect } from 'react-redux';
import { viewedAchievements } from '../State/actions';

import NewAchievementItem from './NewAchievementItem';

import starExplosionAnimData from '../../../AnimationFiles/starrow_explo_3.json';


const NewAchievements = (props) => {

    const [stars, setStars] = React.useState([]);

    React.useEffect(() => {
        if (props.data) {

            setStars(props.data.map((star, index) => {
                return star.description.description;
            }))
        }
    }, []);


    React.useEffect(() => {
            setTimeout(() => {
                props.isAchievementsViewed();
            }, 1000);
    }, []);

    return (
        <React.Fragment>
            {stars.map((star, index) => {
                return (
                    <NewAchievementItem
                        key={index}
                        index={index}
                        description={star}
                        animationData={starExplosionAnimData}
                    />
                 )   
             })}
        </React.Fragment>
     )
}

const mapStateToProps = (state) => {
    return {
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        isAchievementsViewed: () => dispatch(viewedAchievements())
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(NewAchievements);